export default __webpack_public_path__ + "static/media/IMG_5585.96aa6282.jpg";